import style from "../rodingenerateboard.module.css";
import {STAGE_ENUM} from "../interface";
import { useTranslation } from "react-i18next";

const ChangeConfirmTip = ({ handleRedo, setStage = false, currentStage = "GEO", handleConfirmOrGenerate }) => {
    const { t } = useTranslation();
    
    const handlerContinue = () => {
        // handleConfirmOrGenerate(true)
        if(currentStage === "GEO") setStage(STAGE_ENUM.SYMMETRICAL)
        else if(currentStage === "MTL") handleConfirmOrGenerate(true)
    }

    return (
        <div
            className={`${style.notSavedTip}`}>
            <div className={style.notSavedContent}>
                <span className={style.notSavedInfo}>
                    {t('RODIN_GENERTAE_BOARD_GEO_NOT_SAVED_TITLE')}?
                </span>
                <div className={style.notSavedBtns}>
                    <button className={style.notSavedRedo} onClick={handleRedo}>
                        {t('RODIN_GENERTAE_BOARD_GEO_NOT_SAVED_TIPS_1')}
                    </button>
                    <button className={style.notSavedContinue}
                            onClick={handlerContinue}>
                        {t('RODIN_GENERTAE_BOARD_GEO_NOT_SAVED_TIPS_2')}
                    </button>
                </div>
            </div>
            <div className={style.polygonSpaceHodler}></div>
        </div>
    )
}

export {ChangeConfirmTip}